import { Button } from '@material-tailwind/react';
import React, { useState } from 'react';
import AnchorLink from 'react-anchor-link-smooth-scroll';

const navItems = [
  { name: 'About', href: '#about' },
  { name: 'Schedule', href: '#schedule' },
  { name: 'Speakers', href: '#speakers' },
];

export const Header: React.FC<{
  children: React.ReactNode;
  isLiveEvent: boolean;
  setOpenDialog: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ children, isLiveEvent, setOpenDialog }) => {
  // State to manage the navbar's visibility
  const [nav, setNav] = useState(false);

  // Toggle function to handle the navbar's display
  const handleNav = () => {
    setNav(!nav);
  };
  return (
    <>
      <div className="bg-none flex justify-between items-center h-24 max-w-100 mx-auto px-4 text-white">
        {/* Logo */}
        <img src="/images/powerlabsLogo.svg" alt="logo" />

        {/* Desktop Navigation */}
        <ul className="hidden md:flex">
          {navItems.map((item, index) => (
            <AnchorLink href={item.href} key={index}>
              <li
                key={index}
                className="p-3 hover:bg-[#1D1E23] rounded-full m-2 cursor-pointer duration-300 "
              >
                {item.name}
              </li>
            </AnchorLink>
          ))}
        </ul>

        <div>
          <Button
            className="rounded bg-primary"
            placeholder={undefined}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
            disabled={!isLiveEvent}
            onClick={() => setOpenDialog(true)}
          >
            Register
          </Button>
        </div>

        {/* Mobile Navigation Icon */}
        <div onClick={handleNav} className="block md:hidden">
          {nav ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 fixed top-[30px] right-[20px]"
              style={{ zIndex: '99' }}
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="w-6 h-6 "
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          )}
        </div>

        {/* Mobile Navigation Menu */}
        <ul
          className={
            nav
              ? 'fixed md:hidden left-0 top-0 w-[60%] h-full border-r border-r-gray-900 bg-[#0f1015] ease-in-out duration-500'
              : 'ease-in-out w-[60%] duration-500 fixed top-0  bottom-0 left-[-100%]'
          }
          style={{ zIndex: '99' }}
        >
          {/* Mobile Logo */}
          <img src="/images/powerlabsLogo.svg" alt="logo" className="mt-5 ml-3" />

          {/* Mobile Navigation Items */}
          {navItems.map((item, index) => (
            <AnchorLink href={item.href} key={index}>
              <li
                key={index}
                className="p-4 border-b hover:bg-primary duration-300 hover:text-white cursor-pointer border-gray-600"
              >
                {item.name}
              </li>
            </AnchorLink>
          ))}
        </ul>
      </div>
      {children}
    </>
  );
};
